<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 18.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666z"
      stroke="currentColor"
      stroke-width="1.25"
    />
    <path
      d="M10 6.667V10M10 13.333h.008"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
</template>
<script setup lang="ts" />
